module.exports = __webpack_public_path__ + "static/media/card.4299b26b.png";